<template>
    <div style="position: sticky;top: 10px;" id="results-wrapper">
        <h2 class="white--text" style="padding: 7px 15px;border-radius: 5px 5px 0px 0px;background: #63376A">
            Результаты
        </h2>
        <v-card>
            <v-card-text>
              <div class="risk-factors-wrapper block-wrapper" v-if="riskFactorsExist">
                <v-avatar color="red" size="40" >
                  <span class="white--text subtitle-1">ФР</span>
                </v-avatar>
                <span class="result-icon hp-icon" v-for="fr in frList" :key="fr.key" :class="fr.icons.hover"></span>
                <v-divider></v-divider>
              </div>
              <div class="damages-wrapper block-wrapper" v-if="damagesExist">
                <v-avatar color="indigo" size="40" >
                  <span class="white--text subtitle-1">ПОМ</span>
                </v-avatar>
                <span class="result-icon hp-icon" v-for="pom in pomList" :key="pom.key" :class="pom.icons.hover"></span>
                <v-divider></v-divider>
              </div>
              <div class="damages-wrapper block-wrapper" v-if="clinicalConditionsExist">
                <v-avatar color="cyan" size="40" >
                  <span class="white--text subtitle-1">АКС</span>
                </v-avatar>
                <span class="result-icon hp-icon" v-for="aks in aksList" :key="aks.key" :class="aks.icons.hover"></span>
                <v-divider></v-divider>
              </div>
              <div v-if="pressure.sad != '' || pressure.dad != ''" class='result-pressure-wrapper display-1 black--text'> {{ pressure.sad }} / {{ pressure.dad }}</div>
              <div v-if="hypertensionDegrees" class='result-hypertension-wrapper black--text' > {{ hypertensionDegrees }}</div>
              <div v-if="cardiovascularRisk.key != 'none'" class="black--text">
                <div class="risk-name-wrapper" v-if="cardiovascularRisk.name !== ''">
                  {{ cardiovascularRisk.name }}
                </div>
                <div class="recomendations-wrapper">
                  <h4 class="black--text text-center">Рекомендации:</h4>
                  <div v-html="cardiovascularRisk.recomendations"></div>
                </div>
                <div class="hypertonic-wrapper" v-if="hypertonicDiseasse !== false">
                  <h4 class="black--text text-center">{{ hypertonicDiseasse }}</h4>
                </div>
              </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Results',
  data: () => {
    return {}
  },
  methods: {
    getRiskForIsolate (isolateString) {
        let parts = isolateString.split('.')
        let degree =  parts.pop()
        switch (degree) {
            case '1':
              return this.getRiskForDegree1()
              break
            case '2':
              return this.getRiskForDegree2()
              break
            case '3':
              return this.getRiskForDegree3()
              break
            default:
              return this.getRiskForDegreeNone()
        }
    },
    getRiskForIsolateDad (isolateString) {
        let parts = isolateString.split('.')
        let degree =  parts.pop()
        switch (degree) {
            case '1':
              return this.getRiskForDegree1()
              break
            case '2':
              return this.getRiskForDegree2()
              break
            case '3':
              return this.getRiskForDegree3()
              break
            default:
              return this.getRiskForDegreeNone()
        }
    },
    getRiskForDegree1 () {
      if (this.clinicalConditionsExist) {
        return 'veryHigh';
      }
      if (this.damagesExist) {
        return 'high'
      }
      if (this.riskFactorsExist && this.frList.length > 2) {
        return 'high'
      }
      if (this.riskFactorsExist && this.frList.length < 3) {
        return 'middle'
      }
      if (!this.riskFactorsExist) {
        return 'low'
      }
    },
    getRiskForDegree2 () {
      if (this.clinicalConditionsExist) {
          return 'veryHigh';
      }
      if (this.damagesExist) {
          return 'high'
      }
      if (this.riskFactorsExist && this.frList.length > 2) {
          return 'high'
      }
      if (this.riskFactorsExist && this.frList.length < 3) {
          return 'high'
      }
      if (!this.riskFactorsExist) {
          return 'middle'
      }
     },
    getRiskForDegree3 () {
      if (this.clinicalConditionsExist) {
          return 'veryHigh';
      }
      if (this.damagesExist) {
          return 'veryHigh'
      }
      if (this.riskFactorsExist && this.frList.length > 2) {
          return 'high'
      }
      if (this.riskFactorsExist && this.frList.length < 3) {
          return 'high'
      }
      if (!this.riskFactorsExist) {
          return 'high'
      }
    },
    getRiskForDegreeNone () {
      if (this.clinicalConditionsExist) {
          return 'veryHigh';
      }
      if (this.damagesExist) {
          return 'high'
      }
      if (this.riskFactorsExist && this.frList.length > 2) {
          return 'middle'
      }
      if (this.riskFactorsExist && this.frList.length < 3) {
          return 'low'
      }
      if (!this.riskFactorsExist) {
          return 'none'
      }
    },
    getRiskForDegreeHighNormal () {
      return 'noneHigh';
      if (this.clinicalConditionsExist) {
          return 'veryHigh';
      }
      if (this.damagesExist) {
          return 'high'
      }
      if (this.riskFactorsExist && this.frList.length > 2) {
          return 'middle'
      }
      if (this.riskFactorsExist && this.frList.length < 3) {
          return 'middle'
      }
      if (!this.riskFactorsExist) {
          return 'low'
      }
    },
  },
  computed: {
    pressure: function () {
      return this.$store.getters.pressure
    },
    hypertensionDegrees: function () {
      let degreeKey = this.$store.state.results.hypertensionDegreesKey
      let result =  this.$store.getters.hypertensionDegree
      if (typeof degreeKey === 'string' && (degreeKey.indexOf('isolate') !== -1 || degreeKey.indexOf('dadIsolate') !== -1) ) {
          let degreeNumber = degreeKey.split('.').pop()
          result += ' ' + degreeNumber + '-ой степени'
      }
      return result
    },
    hypertensionDegreesKey: function () {
      return this.$store.state.results.hypertensionDegreesKey
    },
    hypertensionExists: function () {
      let key =  this.hypertensionDegreesKey
      return !(key === false || key === 'none' || key === '0')
    },
    riskFactorsExist: function () {
      return this.$store.state.results.riskFactors.length > 0
    },
    damagesExist: function () {
      return this.$store.state.results.targetOrganDamages.length > 0
    },
    clinicalConditionsExist: function () {
      return this.$store.state.results.associatedClinicalConditions.length > 0
    },
    frList: function () {
      return this.$store.state.results.riskFactors
    },
    pomList: function () {
      return this.$store.state.results.targetOrganDamages
    },
    aksList: function () {
      return this.$store.state.results.associatedClinicalConditions
    },
    cardiovascularRisk: function () {
      let everythinIsOK = false
      let noPomAndAks = !this.damagesExist && !this.clinicalConditionsExist
      if (!this.riskFactorsExist && noPomAndAks) {
        if (this.hypertensionDegreesKey === 'none' || this.hypertensionDegreesKey === false)
          everythinIsOK = true
      }
      let riskKey = false
      if (everythinIsOK) {
        riskKey = 'none'
      }
      if (!riskKey && this.hypertensionDegreesKey == 'none') {
          riskKey = this.getRiskForDegreeNone()
      }
      if (!riskKey && this.hypertensionDegreesKey == 0) {
          riskKey = this.getRiskForDegreeHighNormal()
      }
      if (!riskKey && this.hypertensionDegreesKey == 1) {
        riskKey = this.getRiskForDegree1()
      }
      if (!riskKey && this.hypertensionDegreesKey == 2) {
        riskKey = this.getRiskForDegree2()
      }
      if (!riskKey && this.hypertensionDegreesKey == 3) {
        riskKey = this.getRiskForDegree3()
      }
      if (!riskKey && this.hypertensionDegreesKey.indexOf('dadIsolate') !== -1) {
          riskKey = this.getRiskForIsolateDad(this.hypertensionDegreesKey)
      }
      if (!riskKey && this.hypertensionDegreesKey.indexOf('isolate') !== -1) {
          riskKey = this.getRiskForIsolate(this.hypertensionDegreesKey)
      }
      if (!riskKey) {
        riskKey = 'none'
      }
      return this.$store.state.descriptions.cardiovascularRisk[riskKey]
    },
    hypertonicDiseasse: function () {
      if (!this.hypertensionExists) {
        return false
      }
      if (this.clinicalConditionsExist) {
        return '3 стадия гипертонической болезни.'
      }
      if (this.damagesExist) {
        return '2 стадия гипертонической болезни.'
      }
      return '1 стадия гипертонической болезни.'
    }
  },
}
</script>

<style scoped lang='scss'>
  .result-pressure-wrapper {
    text-align: center;
  }
  .result-hypertension-wrapper {
    text-align: center;
    background: rgba(0,0,0,0.05);
    font-size: 18px;
    font-weight: 500;
    padding: 5px;
  }
  .block-wrapper {
    padding-top: 5px;
    >hr{
      margin-top: 5px;
    }
    .result-icon {
      font-size: 24px;
      color: #456ddd;
      margin-right: 4px;
    }
    .v-avatar {
      margin-right: 10px;
    }
  }
</style>
<style lang="scss">
  .risk-name-wrapper, .hypertonic-wrapper, .recomendations-wrapper  {
    text-align: center;
    background: rgba(0,0,0,0.05);
    font-size: 18px;
    font-weight: 500;
    padding: 5px;
    margin-top: 15px;
  }
  .recomendations-wrapper {
    >div {
      a.recomendation-link {
        text-decoration: none!important;
        font-weight: 500;
        font-size: 16px;
        color: #456ddd;
      }
    }
  }
</style>
